import React from 'react';

interface BasicInformationSectionProps {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  onFirstNameChange: (v: string) => void;
  onLastNameChange: (v: string) => void;
  onPhoneChange: (v: string) => void;
  onSaveChanges: () => void;
  saving?: boolean;
}

const BasicInformationSection: React.FC<BasicInformationSectionProps> = ({
  firstName,
  lastName,
  email,
  phone,
  onFirstNameChange,
  onLastNameChange,
  onPhoneChange,
  onSaveChanges,
  saving,
}) => {
  const inputClass =
    'w-full px-4 py-3 border border-outline-variant rounded-xl bg-surface text-on-surface focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm';

  return (
    <section className="p-6">
      <h2 className="font-title-lg text-on-surface mb-4">Basic information</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-on-surface-variant mb-1">First name</label>
          <input
            type="text"
            className={inputClass}
            value={firstName}
            onChange={e => onFirstNameChange(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-on-surface-variant mb-1">Last name</label>
          <input
            type="text"
            className={inputClass}
            value={lastName}
            onChange={e => onLastNameChange(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-on-surface-variant mb-1">Email</label>
          <input
            type="email"
            className={`${inputClass} opacity-60 cursor-not-allowed`}
            value={email}
            disabled
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-on-surface-variant mb-1">Phone (optional)</label>
          <input
            type="tel"
            className={inputClass}
            value={phone}
            onChange={e => onPhoneChange(e.target.value)}
          />
        </div>
      </div>
      <div className="mt-5 flex justify-end">
        <button
          onClick={onSaveChanges}
          disabled={saving}
          className="px-6 py-2.5 bg-primary text-on-primary text-sm font-semibold rounded-xl hover:brightness-110 active:scale-95 transition-all disabled:opacity-50"
        >
          {saving ? 'Saving...' : 'Save changes'}
        </button>
      </div>
    </section>
  );
};

export default BasicInformationSection;
